import { PopupReturnTypeWithPayload } from '../../../../hooks/usePopup'
import { initialPopup } from '../../../../hooks/constants'
import { TLedByDetails } from '../../types'

export const itemsActions = [
  {
    key: 'terminate',
    label: 'Terminate evaluation'
  },
  {
    key: 'review_details',
    label: 'Clinical review details'
  },
  {
    key: 'accept',
    label: 'Accept contract category'
  }
]

export const emptyStateClinicalResults = {
  accepted: [],
  declined: [],
  not_reviewed: []
}

export const contactPersonsPopupWithPayload: PopupReturnTypeWithPayload<TLedByDetails> =
  {
    state: {
      ...initialPopup?.state,
      payload: {} as TLedByDetails
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }
